import { CommonHelper } from './../../../shared/helpers/CommonHelper';
import { ToastsManager } from 'ng2-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Cnae } from '../../../models/Cnae.model';
import { CnaeService } from './../../../services/cnae.service';
import { Component, OnInit } from '@angular/core';
import { DropDownList } from '../../../models/DropDownList.model';
import { SapItemType } from '../../../shared/enums/SapItemType';
import {​​​ ErrorHandlerProvider }​​​ from'../../../shared/providers/errorHandler.provider';
@Component({
    selector: 'app-cnaes-edit',
    templateUrl: './cnaes-edit.component.html',
    styleUrls: ['./cnaes-edit.component.css']
})
export class CnaeEditComponent implements OnInit {
    loading: boolean = false;
    cnaeForm: FormGroup;
    id;
    cnae: Cnae = new Cnae();
    cnaesSap = [];
    downloadUrl: string = '';
    commonHelper: CommonHelper = new CommonHelper();
    SapItemType = SapItemType;

    dropDownCnaesList: DropDownList[] = new Array<DropDownList>();
    selectedCnae: DropDownList[] = new Array<DropDownList>();
    dropDownCnaesSettings = {};

    constructor(private cnaeService: CnaeService,
        private formBuilder: FormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        public toastr: ToastsManager,
        private errorHandler: ErrorHandlerProvider
    ) { }

    async ngOnInit() {
        this.loading = true;
        this.cnaeForm = this.formBuilder.group({
            name: [null, Validators.required],
        });

        this.cnae = await this.cnaeService.getById(this.route.snapshot.params['id']);
        this.cnaesSap = await this.cnaeService.getAllCnaesSap();

        this.dropDownCnaesList = this.cnaesSap.map(item => ({
            id: item.sapKey, itemName: `${item.cnae} - ${item.description}`
        }));

        this.dropDownCnaesSettings = this.commonHelper.getDropDownSettings(true, 'CNAEs', false, '', '', true, null, '', true);
        if(this.cnae.type == SapItemType.CnaeBilling || this.cnae.type == SapItemType.CnaeConsultant)
            this.dropDownCnaesSettings = { ...this.dropDownCnaesSettings, disabled: false };

        const cnaeData = this.cnaesSap.find(c => c.cnae === this.cnae.cnae);
        if(cnaeData)
            this.selectedCnae = [{ id: cnaeData.sapKey, itemName: `${cnaeData.cnae} - ${cnaeData.description}` }];

        this.loading = false;
    }

    async edit() {
        try {
            if(this.selectedCnae.length > 0) {
                const cnaeSelected = this.cnaesSap.find(c => c.sapKey === this.selectedCnae[0].id);
                this.cnae.cnae = cnaeSelected.cnae;
                this.cnae.sapKey = cnaeSelected.sapKey;
            }

            if(this.cnae.name.length > 100) 
                return this.toastr.warning('O nome do Item é longo demais, permitido apenas 100 caracteres!', 'Erro no módulo CNAE e Itens.');

            let response = await this.cnaeService.update(this.cnae);
            if(response._id) {
                this.toastr.success('Cnae/Item alterado com sucesso!');
            } else {
                this.errorHandler.interceptError(response, 'CNAEs e Itens');
            }
            this.router.navigate(['/cnaes']);
        } catch (err) {
            this.router.navigate(['/cnaes']);
            this.errorHandler.interceptError(err, 'CNAEs e Itens');
        }
    }

    OnCancel() {
        this.router.navigate(['/cnaes']);
    }

    verifyValidTouched(fieldName) {
        return !this.cnaeForm.get(fieldName).valid && this.cnaeForm.get(fieldName).touched;
    }

    applyErrorCss(fieldName) {
        return {
            'has-error': this.verifyValidTouched(fieldName)
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/views/cnaes/cnaes-edit/cnaes-edit.component.ts